import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import LeftSide from './LeftSide';
import RightSide from './RightSide';

const styles = (theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  leftSide: {
    flexBasis: theme.dimensions.md,
    flexShrink: 0,
    width: theme.dimensions.md,
  },
  rightSide: {
    flexGrow: 1,
  },
});

const MainContent = ({
  className,
  classes,
  resource,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <LeftSide className={classes.leftSide} resource={resource} />
      <RightSide className={classes.rightSide} />
    </Box>
  );
};

MainContent.defaultProps = {
  className: '',
};

MainContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainContent);
